module.exports = __webpack_public_path__ + "static/media/PictoQuadrante_2pt.60bcac61.svg";